/**
 * @generated SignedSource<<79e153f29dd0e5b6535e0045a831c573>>
 * @relayHash 917b6aef057271dc733fc084b2366d33
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 623fdb354f90eb0a2ba60c9e137a3baa3d7f01383f94a8ae416f2ed275186b7e

var node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "commentId"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "issueKey"
    },
    v3 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }, {
      "kind": "Variable",
      "name": "key",
      "variableName": "issueKey"
    }],
    v4 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v5 = {
      "kind": "ScalarField",
      "name": "projectType"
    },
    v6 = {
      "kind": "ScalarField",
      "name": "projectId"
    },
    v7 = {
      "alias": "canAddComments",
      "args": [{
        "kind": "Literal",
        "name": "permission",
        "value": "ADD_COMMENTS"
      }],
      "kind": "ScalarField",
      "name": "hasProjectPermission",
      "storageKey": "hasProjectPermission(permission:\"ADD_COMMENTS\")"
    },
    v8 = [{
      "kind": "Literal",
      "name": "afterTarget",
      "value": 1
    }, {
      "kind": "Literal",
      "name": "beforeTarget",
      "value": 0
    }, {
      "kind": "Variable",
      "name": "targetId",
      "variableName": "commentId"
    }],
    v9 = {
      "kind": "ScalarField",
      "name": "commentId"
    },
    v10 = {
      "kind": "ScalarField",
      "name": "threadParentId"
    };
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/],
      "kind": "Fragment",
      "name": "mainCommentIssueDataQuery",
      "selections": [{
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [{
          "args": v3 /*: any*/,
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issueByKey",
          "plural": false,
          "selections": [v4 /*: any*/, {
            "concreteType": "JiraProjectField",
            "kind": "LinkedField",
            "name": "projectField",
            "plural": false,
            "selections": [{
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [v5 /*: any*/, v6 /*: any*/]
            }]
          }, v7 /*: any*/, {
            "args": v8 /*: any*/,
            "concreteType": "JiraCommentConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [{
              "concreteType": "JiraCommentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [v9 /*: any*/, v10 /*: any*/]
              }]
            }]
          }]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v2 /*: any*/, v1 /*: any*/, v0 /*: any*/],
      "kind": "Operation",
      "name": "mainCommentIssueDataQuery",
      "selections": [{
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [{
          "args": v3 /*: any*/,
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issueByKey",
          "plural": false,
          "selections": [v4 /*: any*/, {
            "concreteType": "JiraProjectField",
            "kind": "LinkedField",
            "name": "projectField",
            "plural": false,
            "selections": [{
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [v5 /*: any*/, v6 /*: any*/, v4 /*: any*/]
            }, v4 /*: any*/]
          }, v7 /*: any*/, {
            "args": v8 /*: any*/,
            "concreteType": "JiraCommentConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [{
              "concreteType": "JiraCommentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "name": "__typename"
                }, v9 /*: any*/, v10 /*: any*/, {
                  "kind": "InlineFragment",
                  "selections": [v4 /*: any*/],
                  "type": "Node",
                  "abstractKey": "__isNode"
                }]
              }]
            }]
          }]
        }]
      }]
    },
    "params": {
      "id": "623fdb354f90eb0a2ba60c9e137a3baa3d7f01383f94a8ae416f2ed275186b7e",
      "metadata": {},
      "name": "mainCommentIssueDataQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "4d65b809d43f1791309439db2990aa89";
export default node;